import { z } from 'zod';
import { PRODUCT_RESULTS } from '@fortem-monorepo/constants';
import { baseInstrumentSchema } from './base.schema';
import { underlyingsSchema } from './underlyings.schema';
export const baseStructuredSchema = baseInstrumentSchema
    .extend({
    product_result: z.enum(PRODUCT_RESULTS),
    structure_name: z.string().min(1),
    currency_id: z.number().int().positive(),
    counterparty_id: z.number().int().positive(),
    isin: z.string().nullable(),
    sedol: z.string().nullable(),
    notional: z.number().nullable(),
    fund_id: z.number().int().positive(),
    initial_observation_date: z.iso.date(),
    maturity_date: z.iso.date(),
    settlement_cycle: z.number().int().positive(),
    underlyings: underlyingsSchema,
    // Additional Fields
    investment_wrapper: z.string().optional(),
    issuer_name: z.string(),
    guarantor: z.string().optional(),
    guarantor_ratings: z.string().optional(),
    calculation_type: z.string().optional(),
    venue: z.string().optional(),
})
    .superRefine((values, ctx) => {
    const product_result = values.product_result;
    const isin = values.isin;
    if (product_result == 'flow') {
        if (!isin) {
            ctx.addIssue({
                code: 'custom',
                path: ['isin'],
                message: 'ISIN must be filled when creating a flow product.',
            });
        }
        else {
            if (isin.length !== 12) {
                ctx.addIssue({
                    code: 'custom',
                    path: ['isin'],
                    message: 'ISIN must be 12 characters long.',
                });
            }
        }
    }
    if (product_result !== 'flow' && !!isin) {
        ctx.addIssue({
            code: 'custom',
            path: ['isin'],
            message: 'ISIN must be empty when creating a non-flow product.',
        });
    }
});
